module.exports = __webpack_public_path__ + "static/media/no_consignment.4f7a63ef.jpg";